<script setup lang="ts">
import { computed } from 'vue'
import type { Folder } from '../types'
import { childFolders } from '../utils/folderCounts'
const props = defineProps<{ folder: Folder; folders: Folder[]; active: string; expanded: Set<string>; depth: number }>()
const emit = defineEmits<{ select: [string]; toggle: [string] }>()
const children = computed(() => childFolders(props.folders, props.folder.id))
</script>
<template>
  <div class="tree-node" :class="{ active: active === folder.id, open: expanded.has(folder.id) }" :style="{ marginLeft: `${depth * 18}px` }" @click="emit('select', folder.id)">
    <span class="tree-toggle" :class="{ leaf: !children.length }" @click.stop="emit('toggle', folder.id)"></span><span class="tree-folder-tab"></span><span class="tree-label" :title="folder.name">{{ folder.name }}</span>
  </div>
  <template v-if="expanded.has(folder.id)"><FolderTreeNode v-for="child in children" :key="child.id" :folder="child" :folders="folders" :active="active" :expanded="expanded" :depth="depth + 1" @select="emit('select', $event)" @toggle="emit('toggle', $event)" /></template>
</template>
